import { Button, Card, Form, Input, Segmented, Select, Space } from 'antd';
import { useForm } from '@refinedev/antd';
import { IExperienceEvent } from '../../../interfaces/experience';
import { ImageUpload } from '../../../components/form-item/ImageUpload';

const fields = ['id', 'title', 'place', 'catchCopy', 'abstract', { image: ['id', 'url'] }];

export const AbstractForm = () => {
  const { formProps, form, mutationResult, queryResult } = useForm<IExperienceEvent>({
    resource: 'experienceEvents',
    action: 'edit',
    redirect: false,
    meta: {
      fields,
    },
    mutationMeta: {
      fields: [{ experienceEvent: fields }],
    },
  });

  const isLoading = queryResult?.isLoading || mutationResult?.isLoading;

  return (
    <Form data-test-id="AbstractForm" layout="vertical" {...formProps}>
      <Card
        title="概要"
        extra={
          <Space align="end">
            <Button type="primary" htmlType="submit" loading={isLoading}>
              保存
            </Button>
            <Button onClick={() => form.resetFields()}>リセット</Button>
          </Space>
        }
      >
        <Form.Item label="カバー画像" name="image">
          <ImageUpload />
        </Form.Item>
        <Form.Item label="タイトル" name="title">
          <Input />
        </Form.Item>
        <Form.Item label="キャッチコピー" name="catchCopy">
          <Input />
        </Form.Item>
        <Form.Item label="概要" name="abstract">
          <Input.TextArea />
        </Form.Item>
      </Card>
    </Form>
  );
};
